import { Fade } from "@mui/material";
import { useUnits } from "../../contexts";
import { PageHeader, UnitCard } from "../../components";
import * as s from "./styles";

const Units = () => {
  const { units, handleOpenUnitDetails } = useUnits();
  const unitsList = units.filter((unit) => !unit?.deleted);

  return (
    <Fade in timeout={1000}>
      <s.PageContainer>
        <PageHeader label="Unidades" />
        <s.UnitsContainer>
          {unitsList.map((unit) => (
            <UnitCard
              unit={unit}
              key={unit.unitId}
              handleOpenUnit={handleOpenUnitDetails}
            />
          ))}
        </s.UnitsContainer>
      </s.PageContainer>
    </Fade>
  );
};

export default Units;
